import { Switch } from '@affine/component';
import { SettingRow } from '@affine/component/setting-components';
import { useAppSettingHelper } from '@affine/core/components/hooks/affine/use-app-setting-helper';
import { useI18n } from '@affine/i18n';

export const UncategorizedFolderSetting = () => {
  const t = useI18n();
  const { appSettings, updateSettings } = useAppSettingHelper();

  return (
    <SettingRow
      name={t['com.affine.appearanceSettings.showUncategorizedFolder.title']()}
      desc={t[
        'com.affine.appearanceSettings.showUncategorizedFolder.description'
      ]()}
      data-testid="show-uncategorized-folder-trigger"
    >
      <Switch
        checked={appSettings.showUncategorizedFolder}
        onChange={checked => updateSettings('showUncategorizedFolder', checked)}
      />
    </SettingRow>
  );
};
